import { useState } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { apiSetSubmitStage } from "utils/API/TrxNowAPI";
import { Header, PaginationHelper, TitleBar } from "webapp/components";
import ECCMemberSearchForm from "webapp/components/Partner/ECC/ECCMemberSearchForm/ECCMemberSearchForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function ECCMemberSearch(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  const [phoneNumber, setPhoneNumber] = useState(
    props.context.state.MemberLookup.phoneNumber || props.context.state.phoneNumber || "",
  );

  const [firstName, setFirstName] = useState(props.context.state.MemberLookup.firstName || props.firstName || "");

  const [lastName, setLastName] = useState(props.context.state.MemberLookup.lastName || props.lastName || "");

  const [accessCode, setAccessCode] = useState(
    props.context.state.MemberLookup.accessCode || props.context.state.accessCode || "",
  );

  const [searchType, setSearchType] = useState(
    props.context.state.MemberLookup.searchType || props.context.state.searchType || "",
  );

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onUserNext = () => {
    devLog("formRef", formRef);
    if (typeof formRef.onUserNext === "function") {
      formRef.current.submit();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onFormLoad = (ref) => {
    devLog("onFormLoad", formRef, ref);
    formRef.current = ref;
    devLog("onFormLoad", formRef);
  };

  const onFormUpdate = (data) => {
    devLog("onFormUpdate", data);
    if (typeof data === "object") {
      if (typeof data.phoneNumber === "string") {
        setPhoneNumber(data.phoneNumber.replace(/[()\s-]/g, ""));
      }
      if (typeof data.accessCode === "string") {
        setAccessCode(data.accessCode);
      }
      if (typeof data.firstName === "string") {
        setFirstName(data.firstName);
      }
      if (typeof data.lastName === "string") {
        setLastName(data.lastName);
      }
      if (typeof data.searchType === "string") {
        setSearchType(data.searchType);
      }
    }
  };

  const onFormSubmit = (data) => {
    const context = props.context;
    const naviState = context.state.navigationService.getState(AppState.MemberSearch);
    devLog("ContractSearch", naviState);
    onFormUpdate(data);
    const nextState =
      naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmVehicle;
    context.setState(
      {
        webAppState: nextState,
        FirstName: !!data.firstName ? data.firstName : context.state.FirstName,
        LastName: !!data.lastName ? data.lastName : context.state.LastName,
        MemberLookup: {
          // memberNumber: data.memberNumber,
          firstName: data.firstName,
          lastName: data.lastName,
          phoneNumber: data.phoneNumber,
          accessCode: data.accessCode,
          searchType: data.searchType,
          // decalNumber: data.decalNumber,
          // last8Vin: data.last8Vin,
        },
      },
      () => {
        apiSetSubmitStage(
          context.state,
          nextState,
          context.state.DisablementAddress || "DisablementAddress Not Available",
        );
        context.saveWebAppState(context);
      },
    );
  };

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("description.AccessCodeTitleBar")}</strong>
          <br />
        </p>
      </>
    ),
  };

  return (
    <div>
      <Header currState={props.currState} onUserBack={onUserBack} information={t("APIA.ContractSearch.TitleBar1")} />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />
      <ECCMemberSearchForm
        firstName={firstName}
        lastName={lastName}
        phoneNumber={phoneNumber}
        accessCode={accessCode}
        searchType={searchType}
        onFormUpdate={onFormUpdate}
        onFormLoad={onFormLoad}
        onFormSubmit={onFormSubmit}
        onUserCancel={onUserCancel}
        onNextClick={onUserNext}
        currState={props.currState}
      />
    </div>
  );
}

export default ECCMemberSearch;
